import React from "react";

import MembershipLayer from "../components/MembershipLayer";

const MembershipPage = () => {
  return (
    <>

      {/* SignUpLayer */}
      <MembershipLayer />

    </>
  );
};

export default MembershipPage;
